import { Menu } from 'lucide-react';
import { Breadcrumbs } from './Breadcrumbs';
import { ClientSwitcher } from './ClientSwitcher';
import { NotificationsBell } from './NotificationsBell';
import { ThemeToggle } from './ThemeToggle';
import { UserMenu } from './UserMenu';

interface TopbarProps {
  onOpenMobileMenu: () => void;
  showClientSwitcher?: boolean;
  allowAllClients?: boolean;
}

export function Topbar({
  onOpenMobileMenu,
  showClientSwitcher = true,
  allowAllClients = true,
}: TopbarProps) {
  return (
    <header className="sticky top-0 z-30 border-b border-line bg-surface/95 backdrop-blur">
      <div className="flex h-14 items-center gap-2 px-3 sm:px-4">
        <button
          type="button"
          onClick={onOpenMobileMenu}
          aria-label="Abrir menu"
          className="rounded-lg p-2 text-muted transition hover:bg-elevated hover:text-fg lg:hidden"
        >
          <Menu className="h-5 w-5" aria-hidden />
        </button>

        {showClientSwitcher && <ClientSwitcher allowAll={allowAllClients} />}

        <div className="ml-auto flex items-center gap-1.5">
          <ThemeToggle className="hidden sm:flex" />
          <NotificationsBell />
          <UserMenu />
        </div>
      </div>

      <div className="hidden border-t border-line/60 px-4 py-1.5 sm:block">
        <Breadcrumbs />
      </div>
    </header>
  );
}
